<template>
  <div class="search-result">
    <!-- <van-address-edit
          :address-info="AddressInfo"
          :area-list="areaList"
          :show-postal=false
          :show-delete="showDelete"
          show-set-default
          :show-search-result=false
          :search-result="searchResult"
          :area-columns-placeholder="['请选择', '请选择', '请选择']"
          @save="onSave"
          @delete="onDelete"
          @change-detail="onChangeDetail"
        /> -->

    <van-field v-model="AddressInfo.consignee" type="text" placeholder="请输入收货人姓名" label="姓名" />
    <van-field v-model="AddressInfo.phone_mob" type="tel" error-message="" placeholder="请输入手机号" label="电话" />
    <van-field v-model="AddressInfo.region_name" readonly type="text" @click="showDong" placeholder="选择省/市/区"
      right-icon="arrow" label="地区" />
    <van-field v-model="AddressInfo.address" type="text" placeholder="请填写详细地址" label="详细地址" />
    <van-cell center title="设为默认收货地址">
      <van-switch v-model="AddressInfo.default" slot="right-icon" size="24" />
    </van-cell>
    <!--<cascadePicker v-if="isShow" @emitCancel="emitCancel" @emitConfirm="emitConfirm"></cascadePicker>-->
    <newPicker :cityList='cityList' v-if="isShow" @emitCancel="emitCancel" @emitConfirm="emitConfirm"></newPicker>
    <div class="van-address-edit__buttons">
      <van-button size="large" @click="onSave()" type="danger">保存</van-button>
      <van-button v-if="showDelete && btnHide" @click="onDelete()" size="large" type="default">删除</van-button>
    </div>
    <mloading v-if='loading'></mloading>
  </div>
</template>

<script>
  import { Toast, Dialog } from 'vant'
  import { sendRequest } from '@/assets/public'
  import cascadePicker from '@/components/cascadePicker.vue'
  import newPicker from '@/components/newPicker.vue'
  import mloading from "@/components/loading.vue";

  export default {
    components: {
      newPicker,
      mloading
    },
    data() {
      return {
        btnHide: true, //默认隐藏
        showDelete: false,
        isShow: false,
        searchResult: [],
        PromptInfo: {
          telInfo: '',
        },
        AddressInfo: {
          consignee: '',
          phone_mob: '',
          region_name: '',
          province: '',
          city: '',
          area: '',
          address: '',
          default: 0,
        },
        loading: true
      }
    },

    async created() {
      this.goodsId = localStorage.getItem('goodsId')
        ? JSON.stringify(localStorage.getItem('goodsId'))
        : 0

      if (this.goodsId != 0) {
        this.btnHide = false
      }

      let modification = this.$router.history.current.query.modification
      let editId = this.$router.history.current.query.editId
      document.title = modification == 'add' ? '添加地址' : '编辑地址'
      this.showDelete =
        modification == 'add' ? false : modification == 'modify' ? true : false
      this.cityFg()
      let { content, status, msg } = await sendRequest('user/getAddress', {
        addr_id: editId,
      })
      if (status == 200) {
        content.default = content.default == '1' ? true : false
        this.AddressInfo = content
      }
      // localStorage.removeItem('goodsId')
    },

    methods: {
      async cityFg() {
        let res = await sendRequest('user/getArea', {
          region_id: 0,
        })
        if (res.status == 200) {
          this.cityList = res.content
        }
        this.loading = false
      },
      showDong() {
        this.isShow = true
        document.body.style.overflow = 'hidden'
      },
      emitConfirm(ev) {
        document.body.style.overflow = 'auto'

        this.AddressInfo.region_name = ev.val.join()
        this.AddressInfo.province = ev.provinceId[0]
        this.AddressInfo.city = ev.provinceId[1]
        this.AddressInfo.area = ev.provinceId[2]
        this.isShow = false
      },
      emitCancel(ev) {
        this.isShow = false
        document.body.style.overflow = 'auto'
      },
      async onSave(save) {
        if (!this.AddressInfo.consignee) {
          Toast('用户名不能为空')
          return false
        }

        if (!this.AddressInfo.region_name && this.AddressInfo.phone_mob) {
          Toast('请选择省市区')
          return false
        }
        if (!this.AddressInfo.address) {
          Toast('详情地址不能为空')
          return false
        }
        if (this.showDelete) {
          this.AddressInfo.default = this.AddressInfo.default == true ? 1 : 0
          this.AddressInfo.set_default = 0
        } else {
          this.AddressInfo.is_show = 1
        }
        let goodsId = localStorage.getItem('goodsId')

        // /user/addAddr

        let { status, msg } = await sendRequest(
          this.showDelete ? 'user/editAddr' : 'user/addAddr',
          this.AddressInfo
        )
        msg == 'OK'
          ? Toast(this.showDelete ? '修改成功' : '添加成功')
          : Toast(msg)
        if (msg == 'OK') {
          // this.$router.replace({
          // 	name: 'addressList',
          // 	query:{
          // 		isDetails:goodsId ?true:false,
          // 		id:goodsId,
          // 		addr_id:this.$route.query.addr_id ? this.$route.query.addr_id:null
          // 	}
          // });
          this.$router.go(-1)
        }
      },
      async onDelete() {
        Dialog.confirm({
          title: '提示',
          message: '确定要删除吗？',
          confirmButtonColor: '#FD3E3E'
        }).then(async () => {
          let { status, msg } = await sendRequest('/user/delAddr', this.AddressInfo)
          let goodsId = localStorage.getItem('goodsId')
          this.$router.push({
            name: 'addressList',
            query: {
              isDetails: goodsId ? true : false,
              id: goodsId,
            },
          })
        }).catch(() => {
        });

      },

      onChangeDetail(val) {
        if (val) {
          this.searchResult = [
            {
              name: '黄龙万科中心',
              address: '杭州市西湖区',
            },
          ]
        } else {
          this.searchResult = []
        }
      },
    },
  }
</script>

<style>
  .search-result {
    padding-top: 0.4rem;
  }

  .search-result .van-cell {
    width: 100%;
    text-align: left;
  }

  .search-result .van-address-edit__buttons {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0.4rem;
    box-sizing: border-box;
    padding: 0 0.3rem;
    left: 0;
    width: 100%;
    flex-direction: row-reverse;
  }

  .search-result .van-address-edit__buttons .van-button {
    height: 2rem;
    border: 1px solid rgba(253, 62, 62, 1);
    border-radius: 10px;
  }

  .van-button--default {
    background: rgba(0, 0, 0, 0);
    color: rgba(253, 62, 62, 1);
  }

  .van-button--default,
  .van-button--danger {
    margin: 0 0.3rem;
  }

  .search-result .van-switch--on {
    background: red;
  }

  .van-picker__title {
    opacity: 0 !important;
  }
</style>